<template>
  <div class="repayment-plan-item">
    <div class="top">
      <div class="item-left">
        <span class="span">{{item.issueNo}}/{{num}}期</span>
        <span>还款日期：{{item.dueRepaymentTime}}</span>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-left">
        <span class="span blue">本金{{ item.principalAmount }}+</span>
        <span class="span yellow">利息{{ item.interestAmount }}</span>
        <span class="span yellow" v-if="item.serviceFee > 0">服务费+{{ item.serviceFee }}</span>
      </div>
      <div class="bottom-right">
        <span class="amount-tip">￥</span>
        <div>{{(item.interestAmount + item.principalAmount).toFixed(2)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RepaymentPlanItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.repayment-plan-item {
  height: 76px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.04), 0px 4px 7px 0px rgba(0,0,0,0.03);
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .item-left {
      display: flex;
      align-items: center;
      .span {
        font-family: PingFang SC, PingFang SC;
        margin-right: 7px;
        padding: 2px 4px;
        border-radius: 4px;
        color: #D4A038;
        border: 1px solid #D4A038;
        font-weight: 600;
        font-size: 12px;
      }
    }
    .item-right {
      font-size: 10px;
      padding: 2px 4px;
      border-radius: 4px;
      background: #fff;
      color: #01abff;
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .bottom-left {
      display: flex;
      align-items: center;
      .span {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        padding: 1px 0px;
        color: #333333;
      }
    }
    .bottom-right {
      font-weight: 600;
      font-size: 20px;
      display: flex;
      align-items: center;
      .amount-tip{
        font-size: 14px;
      }
    }
  }
}
</style>
